import { Link } from 'react-router-dom'
import { HoverGlowCard } from '../app/components/ui/HoverGlowCard'
import { Skeleton } from '../app/components/ui/skeleton'
import { useChatLauncherPriorities } from './useChatLauncherPriorities'
import styles from './ChatLauncherPriorities.module.scss'

function LoadingCards() {
  return (
    <div
      className={styles.loadingGrid}
      aria-busy="true"
      aria-label="Caricamento priorità Inbox"
    >
      {Array.from({ length: 3 }, (_, index) => (
        <Skeleton key={index} className={styles.loadingCard} aria-hidden="true" />
      ))}
    </div>
  )
}

export function ChatLauncherPriorities({ onNavigate }: { onNavigate?: () => void }) {
  const { loading, priorities } = useChatLauncherPriorities()

  if (!loading && priorities.length === 0) return null

  return (
    <section className={styles.section} aria-label="Priorità Inbox">
      {loading ? <LoadingCards /> : null}
      {priorities.length > 0 ? (
        <ol className={styles.grid}>
          {priorities.map((item, index) => {
            const detail = item.whyNow || item.summary.find(Boolean) || item.suggestedAction
            return (
              <li key={item.fingerprint} className={styles.slot}>
                <HoverGlowCard
                  className={styles.card}
                  innerClassName={styles.cardInner}
                  radiusPx={12}
                  surfaceBackground={
                    index === 0
                      ? 'color-mix(in srgb, var(--arca-color-accent) 8%, var(--arca-stage-panel))'
                      : 'var(--arca-stage-panel)'
                  }
                >
                  <Link
                    to={`/insights?item=${encodeURIComponent(item.fingerprint)}`}
                    className={styles.link}
                    onClick={onNavigate}
                  >
                    <strong className={styles.title}>{item.title}</strong>
                    {detail ? <span className={styles.description}>{detail}</span> : null}
                  </Link>
                </HoverGlowCard>
              </li>
            )
          })}
        </ol>
      ) : null}
    </section>
  )
}
